import { Link } from "react-router";
import pdfIcon from "@assets/icons/icon-pdf-red.svg";
import { cn } from "@util/helpers";

type PDFDownloadProps = {
  /** This is the classname of the component. */
  className?: string;
  /** Link to the PDF Download */
  link: string;
};

/** The PDF link download. Data is pulling from CUE.
 * https://www.figma.com/design/50gwyNfDsv70dHaddmTd7k/BT-SG60--WEB---APP-?node-id=164-79107&m=dev
 */
const PDFDownload = ({
  className,
  link,
}: PDFDownloadProps): React.ReactElement => {
  return (
    <div
      data-testid="pdf-download-component"
      className={cn("flex items-center", className)}
    >
      <div className="flex items-center">
        <img src={pdfIcon} width={30} height={30} alt="Download PDF" />

        <h3 className="m-0 ml-1 font-lct text-base font-semibold leading-[1.3125rem] text-black">
          PDF Version Available
        </h3>
      </div>

      <Link
        to={link}
        className={cn(
          "ml-auto  inline-block rounded-full border border-gray-175 bg-white px-6 py-3 font-poppins text-xs font-semibold tracking-[.0175rem] transition-colors ",
          "hover:border-gray-850",
          "md:ml-4",
          "xl:ml-auto"
        )}
        target="_blank"
      >
        View PDF
      </Link>
    </div>
  );
};

export default PDFDownload;
